import { useSelector } from "react-redux";

import { getAppConfigPresentation, getAppConfigShared } from "../../ducks/appConfig";

export const useIsShared = () => {
  const isShared = useSelector(getAppConfigShared);
  const isPresentation = useSelector(getAppConfigPresentation);

  return process.env.NODE_ENV === "production"
    ? isShared || isPresentation
    : window.location.port === process.env.SHARED_PORT;
};
